import React from 'react';
import { Step } from './calculatorSteps';
import StepIntro from './steps/StepIntro';
import StepChallenges from './steps/StepChallenges';
import StepServices from './steps/StepServices';
import StepWorkshop from './steps/StepWorkshop';
import StepTechnologies from './steps/StepTechnologies';
import StepEstimate from './steps/StepEstimate';
import StepSuccess from './steps/StepSuccess';
import type { CalculatorFormState, SubmissionStatus } from './types';

interface CalculatorStepRouterProps {
  currentStep: number;
  formData: CalculatorFormState;
  submissionStatus: SubmissionStatus;
  onSelectChallenge: (challenge: string) => void;
  onToggleService: (service: string) => void;
  onSetWorkshopType: (type: string) => void;
  onSetTechnologiesText: (value: string) => void;
  onEmailChange: (value: string) => void;
  onTermsToggle: () => void;
  onSubmit: () => void;
  onClose: () => void;
}

const CalculatorStepRouter: React.FC<CalculatorStepRouterProps> = ({
  currentStep,
  formData,
  submissionStatus,
  onSelectChallenge,
  onToggleService,
  onSetWorkshopType,
  onSetTechnologiesText,
  onEmailChange,
  onTermsToggle,
  onSubmit,
  onClose,
}) => {
  switch (currentStep) {
    case Step.Intro:
      return <StepIntro />;
    case Step.Challenges:
      return (
        <StepChallenges selectedChallenges={formData.challenges} onSelect={onSelectChallenge} />
      );
    case Step.Services:
      return <StepServices selectedServices={formData.services} onToggle={onToggleService} />;
    case Step.Workshop:
      return <StepWorkshop selectedType={formData.workshopType} onSelect={onSetWorkshopType} />;
    case Step.Technologies:
      return (
        <StepTechnologies value={formData.technologiesText} onChange={onSetTechnologiesText} />
      );
    case Step.Estimate:
      return (
        <StepEstimate
          formData={formData}
          submissionStatus={submissionStatus}
          onEmailChange={onEmailChange}
          onTermsToggle={onTermsToggle}
          onSubmit={onSubmit}
        />
      );
    case Step.Success:
      return <StepSuccess onClose={onClose} />;
    default:
      return null;
  }
};

export default CalculatorStepRouter;
